export default __webpack_public_path__ + "static/agrid-562eb85996e384ad8331cc107d4c46ce.jpeg";